import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'

interface NumberCellProps {
  hasInvertedColors: boolean
  columnType: string
  title?: string
  children?: ReactNode
}

type StyledNumberCellProps = Pick<
  NumberCellProps,
  'columnType' | 'hasInvertedColors'
>

const StyledNumberCell = styled.div<StyledNumberCellProps>`
  ${({
    theme: {
      colors: { textWeak, staticNeutral400, textDefault, staticNeutral100 },
      spacing: { spacing12 },
      typography: {
        catchword: {
          medium1: { bundledCSS: medium1CatchwordCSS },
          medium2: { bundledCSS: medium2CatchwordCSS },
        },
        headings: {
          xxsmall: { bundledCSS: xxsmallHeadingCSS },
        },
      },
    },
    columnType,
    hasInvertedColors,
  }) => {
    return css`
      display: grid;
      align-items: center;
      width: 100%;
      height: 100%;
      box-sizing: border-box;

      justify-content: right;
      color: ${hasInvertedColors ? staticNeutral400 : textWeak};
      ${medium1CatchwordCSS};

      ${columnType === 'rank' &&
      css`
        ${xxsmallHeadingCSS};
        justify-content: left;
        color: ${hasInvertedColors ? staticNeutral100 : textDefault};
        padding-left: ${spacing12};
      `}

      ${columnType === 'points' &&
      css`
        ${medium2CatchwordCSS};
        justify-content: right;
        color: ${hasInvertedColors ? staticNeutral100 : textDefault};
        padding-right: ${spacing12};
      `}
    `
  }}
`

const NumberCell: FunctionComponent<NumberCellProps> = ({
  title,
  columnType,
  hasInvertedColors,
  children,
}) => {
  return (
    <StyledNumberCell
      {...(columnType === 'rank' && title ? { title } : {})}
      columnType={columnType}
      hasInvertedColors={hasInvertedColors}>
      {children}
    </StyledNumberCell>
  )
}

export default NumberCell
